// analytics/components/charts/StationComparisonChart.jsx

import { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

const chartInstances = {};

const StationComparisonChart = ({ chartId, data, onBarClick }) => {
    const chartRef = useRef(null);

    useEffect(() => {
        if (!chartRef.current || !data || data.length === 0) return;

        if (chartInstances[chartId]) {
            chartInstances[chartId].destroy();
        }

        const ctx = chartRef.current.getContext('2d');
        
        const config = {
            type: 'bar',
            data: {
                labels: data.map(d => d.station_name),
                datasets: [
                    {
                        label: 'Defect Rate (%)',
                        data: data.map(d => (d.statistics.total_inspections > 0 ? (d.statistics.defect_count / d.statistics.total_inspections) * 100 : 0)),
                        backgroundColor: '#dc3545',
                        yAxisID: 'y',
                    },
                    {
                        label: 'Total Inspections',
                        data: data.map(d => d.statistics.total_inspections),
                        backgroundColor: '#007bff',
                        yAxisID: 'y1',
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                onClick: (event, elements) => {
                    if (elements.length > 0) {
                        const clickedIndex = elements[0].index;
                        const stationId = data[clickedIndex].station_id;
                        onBarClick(stationId);
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            autoSkip: false,
                            maxRotation: 45,
                            minRotation: 45
                        }
                    },
                    y: {
                        beginAtZero: true,
                        position: 'left',
                        title: { display: true, text: 'Defect Rate (%)' }
                    },
                    y1: {
                        beginAtZero: true,
                        position: 'right',
                        grid: { drawOnChartArea: false },
                        title: { display: true, text: 'Total Inspections' }
                    }
                }
            }
        };

        chartInstances[chartId] = new Chart(ctx, config);

        return () => {
            if (chartInstances[chartId]) {
                chartInstances[chartId].destroy();
                delete chartInstances[chartId];
            }
        };
    }, [chartId, data, onBarClick]);

    return <canvas ref={chartRef}></canvas>;
};

export default StationComparisonChart;
